const purchaseHistoryIT = {
    "view": {
        "table": {
            "title": "La tua cronologia acquisti",
            "column": {
                "amount": "Importo",
                "description": "Descrizione",
                "credits_balance": "Saldo Crediti",
                "tokens_balance": "Saldo Token",
                "date_of_purchase": "Data di Acquisto",
                "receipt": "Ricevuta"
            },
            "placeholder": {
                "search": "Cerca..."
            },
            "button": {
                "view": "Visualizza",
                "export_csv": "Esporta CSV"
            }
        }
    }
};

export default purchaseHistoryIT;